import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SplitString'
})
export class SplitStringPipe implements PipeTransform {

  transform(value: string): any {
    if (value == null || value === '')
      return '';

    return value.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  }

}
